import Settings from "./settings.service";

const LoadFB = () => {
	if (Settings.fb_app_id) {
			(function(d, s, id) {
				var js,
					fjs = d.getElementsByTagName(s)[0];
				if (d.getElementById(id)) {
					return;
				}
				js = d.createElement(s);
				js.id = id;
				js.src = "https://connect.facebook.net/en_US/sdk.js";
				fjs.parentNode.insertBefore(js, fjs);
			})(document, "script", "facebook-jssdk");
		}

		window.fbAsyncInit = function() {
			window.FB.init({
				appId: Settings.fb_app_id,
				cookie: true,
				xfbml: false,
				version: 'v21.0',
			});

			window.FB.AppEvents.logPageView();
			let fbInitEvent = new Event("FBObjectReady");
			document.dispatchEvent(fbInitEvent);
		};
};

export { LoadFB };
